module.exports = "<div class=\"card\">\n  <div class=\"headling h50 clearfix\" *ngIf=\"hasHeadling\">\n    <i class=\"ico {{ico}} vam mr10 ml10\"></i>\n    <div class=\"description dib vam mt3\">\n      <h3 class=\"title\">{{title}}</h3>\n      <span class=\"subtitle\">{{subtitle}}</span>\n    </div>\n    <ng-content ngClass=\"fr\" select=\"[card-title]\"></ng-content>\n  </div>\n  <hr class=\"separator\" [hidden]=\"!hasContent || !hasHeadling\">\n  <div class=\"content clearfix\" #content [hidden]=\"!hasContent\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/card/card.component.html
// module id = hBOu
// module chunks = 6